import { createRouter, createWebHistory } from "vue-router";
import { getAccessToken, getUserInfo } from "@/lib/api";
import { TEXT } from "@/utils/constant";
import { useRoleStore } from "@/stores/role";
// TODO: 상용 테스트 후 설문 자동 복귀 활성화 시 주석 해제
// import { setSurveyRedirectFlag } from "@/utils/surveyFlag";

import BaseLayout from "@/layouts/BaseLayout.vue";
import BlankLayout from "@/layouts/BlankLayout.vue";
import WorkspaceLayout from "@/layouts/WorkspaceLayout.vue";

import Home from "@/views/Home.vue";
import examRoutes from "./modules/exam";
import myTestRoutes, { myTestWorkspaceRoutes } from "./modules/my-test";
import boardRoutes from "./modules/board";
import oauthRoutes from "./modules/oauth";
import resultRoutes from "./modules/result";
import resultAiRoutes from "./modules/ai-literacy-result";
import resultAi2026Routes from "./modules/ai-literacy-result-2026";
import resultMlsrd2026Routes from "./modules/result-mlsrd-2026";

const routes = [
  {
    path: "/",
    component: BaseLayout,
    children: [
      { path: "", name: "Home", component: Home },
      {
        path: "/senid", // This already shows as "senid" in browser URL
        name: "Senid",
        component: () => import("@/views/Senid.vue"),
      },
      ...examRoutes,
      ...myTestRoutes,
      ...boardRoutes,
      ...oauthRoutes,
    ],
  },
  {
    // 나의 검사 관리 업무 화면(교사): 업무용 헤더 + LNB, 푸터 없음
    path: "/",
    component: WorkspaceLayout,
    children: [...myTestWorkspaceRoutes],
  },
  {
    path: "/",
    component: BlankLayout,
    children: [
      // 메인 화면 A안 (Figma 시안 테스트)
      {
        path: "/main-a",
        name: "MainA",
        component: () => import("@/views/MainA.vue"),
        meta: { title: "메인 A안" },
      },
      // 메인 화면 B안 (신규 시안 퍼블)
      {
        path: "/main-b",
        name: "MainB",
        component: () => import("@/views/MainB.vue"),
        meta: { title: "메인 B안" },
      },
      // 개인정보처리방침
      {
        path: "/privacy",
        name: "PrivacyPopup",
        component: () => import("@/views/popup/PrivacyPopup.vue"),
      },
      // 이용약관
      {
        path: "/terms",
        name: "TermsPopup",
        component: () => import("@/views/popup/TermsPopup.vue"),
      },
      // (교사) 나의 검사 - 사전 점검 - 사전 점검 - 확인
      {
        path: "/pre-check-confirm",
        name: "PreCheckConfirm",
        component: () =>
          import("@/views/my-test/teacher/popup/PreCheckConfirm.vue"),
        props: (route) => ({
          id: route.query.id,
          editable: route.query.editable === "true",
        }),
      },
      // (교사) 나의 검사 - 시험 감독 - 모니터링
      {
        path: "/exam-watch-monitoring",
        name: "ExamWatchMonitoring",
        component: () =>
          import("@/views/my-test/teacher/popup/ExamWatchMonitoring.vue"),
        props: (route) => ({
          id: route.query.id,
        }),
      },
      // (교사) 나의 검사 - 시험 감독 - 체험하기
      {
        path: "/try-watch-monitoring",
        name: "TryWatchMonitoring",
        component: () =>
          import("@/views/my-test/teacher/popup/TryWatchMonitoring.vue"),
      },
      // (교사) 나의 검사 - 시험 감독 - 체험하기 - 투어
      {
        path: "/tour-watch-monitoring",
        name: "TourWatchMonitoring",
        component: () =>
          import("@/views/my-test/teacher/popup/TourWatchMonitoring.vue"),
        props: (route) => ({
          step: route.query.step,
        }),
      },
      // (학생) 나의 검사 - 검사 결과 - 결과보기
      {
        path: "/exam-result-confirm",
        name: "ExamResultConfirm",
        component: () =>
          import("@/views/my-test/teacher/popup/ExamResultConfirm.vue"),
        props: (route) => ({
          id: route.query.id,
        }),
      },
      // 시험 설문 (교사/학교관리자, QR 직접 진입 지원)
      {
        path: "/survey",
        name: "SurveyDetail",
        component: () => import("@/views/survey/SurveyDetail.vue"),
        meta: { title: "설문조사" },
      },
    ],
  },
  { // 결과지(성적표)
    path: "/",
    component: BlankLayout,
    children: [      
      ...resultRoutes
    ],
  },
  { // AI 디지털 리터리시 진단 결과
    path: "/",
    component: BlankLayout,
    children: [      
      ...resultAiRoutes
    ],
  },
  { // AI 디지털 리터러시 진단 결과 (2026)
    path: "/",
    component: BlankLayout,
    children: [      
      ...resultAi2026Routes
    ],
  },
  { // MLSRD 진단검사 결과지 (2026)
    path: "/",
    component: BlankLayout,
    children: [
      ...resultMlsrd2026Routes
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 새로고침/URL 직접 진입(최초 내비게이션)은 항상 최상단으로.
    // vue-router는 beforeunload 시 스크롤 위치를 history.state에 저장해 두고
    // 최초 내비게이션에서도 savedPosition으로 넘겨주기 때문에, 아래 분기보다 먼저 걸러야 한다.
    if (from.matched.length === 0) {
      return { left: 0, top: 0 };
    }
    // 뒤로가기/앞으로가기일 땐 이전 위치로
    if (savedPosition) {
      return savedPosition;
    }
    // 같은 페이지에서 쿼리만 바뀌는 경우(필터 선택 등 URL 동기화)는 스크롤을 유지
    if (to.path === from.path) {
      return false;
    }
    // 그 외에는 제일 위로
    return { left: 0, top: 0 };
  },
});

// Add authentication guard
router.beforeEach((to, from, next) => {
  // Set page title based on meta.title or default system name
  const pageTitle = to.meta?.title ? `${to.meta.title} - ${TEXT.SYSTEM_NAME}` : TEXT.SYSTEM_NAME;
  document.title = pageTitle;

  const accessToken = getAccessToken();

  // Check if route requires authentication (my-test routes)
  if (to.path.startsWith("/my-test") && !accessToken) {
    console.log('Router guard: Unauthorized access to my-test, redirecting to login');
    // Redirect to login - trigger same event as login button click
    window.location.href = process.env.VUE_APP_API_LOGIN_URL;
    return;
  }

  // 설문(QR 진입 포함): 미로그인 시 로그인으로 보낸다.
  // 로그인 후 설문 자동 복귀(플래그 저장 → AuthCallback 에서 확인)는 상용 테스트 전까지 비활성.
  // TODO: 상용 테스트 후 아래 setSurveyRedirectFlag 주석 해제
  if (to.path === "/survey" && !accessToken) {
    // setSurveyRedirectFlag(to.query?.exam_id);
    window.location.href = process.env.VUE_APP_API_LOGIN_URL;
    return;
  }

  const userInfo = getUserInfo();
  const roleStore = useRoleStore();
  const isTeacher = userInfo?.role === "tea";
  const isSchoolAdmin = userInfo?.isSchoolAdmin === "Y" || roleStore.isSchoolAdmin;
  const isGradeAdmin = userInfo?.isGradeAdmin === "Y" || roleStore.isGradeAdmin;
  const hasGradingAccess = userInfo?.hasGradingAccess === "Y" || roleStore.hasGradingAccess;
  // 채점 결과 확인 및 피드백 등록 전용 접근 대상: 담임(CT) / 교장·교감(P/VP)
  const teaRole = userInfo?.teaRole || roleStore.teaRole || "";
  const isFeedbackViewer = teaRole === "CT" || teaRole === "P" || teaRole === "VP";

  if (to.meta?.requiresSchoolAdmin && (!isTeacher || !isSchoolAdmin)) {
    console.log("Router guard: blocked school-admin-only route", to.path);
    next({ name: isTeacher ? "MyTestTeacherPreCheck" : "MyTestGate" });
    return;
  }

  // 채점관리 라우트: 채점 권한자 + 학교/학년 관리자 + 담임/교장·교감(피드백 조회) 허용.
  // 담임/교장·교감은 GradingManage 에서 피드백 탭만 노출되며, 다른 탭 URL 직접 진입 시 첫 노출 탭으로 보정된다.
  if (
    to.meta?.requiresGradingAccess &&
    (!isTeacher || !(isSchoolAdmin || isGradeAdmin || hasGradingAccess || isFeedbackViewer))
  ) {
    console.log("Router guard: blocked grading-access-only route", to.path);
    next({ name: isTeacher ? "MyTestTeacherPreCheck" : "MyTestGate" });
    return;
  }

  // 채점관리 기본 진입(/grading, 특정 탭 없음): 역할에 맞는 첫 탭으로 즉시 이동.
  // 렌더링 전(beforeEach) 단계에서 결정해, 탭이 확정되기 전 빈 화면이 잠깐 보이는 것을 막는다.
  // (과목별 세부 배정(팀장 여부 등)은 GradingManage.vue 진입 후 추가로 보정될 수 있으나,
  //  최소한 학교관리자/채점자 기준의 올바른 기본 탭에서 시작한다.)
  if (to.name === "MyTestTeacherGrading") {
    // 채점 권한이 없는 순수 담임/교장·교감은 피드백 탭만 보이므로 바로 그 탭으로 진입.
    const feedbackViewerOnly =
      isFeedbackViewer && !hasGradingAccess && !isSchoolAdmin && !isGradeAdmin;
    // 채점자는 채점(채점 기준 설정)부터 — 공지사항·모니터링 등 배정 기반 보정은 GradingManage 가 한다
    let defaultGradingTab = "MyTestTeacherGradingCriteria";
    if (feedbackViewerOnly) {
      defaultGradingTab = "MyTestTeacherGradingFeedback";
    } else if (isSchoolAdmin) {
      defaultGradingTab = "MyTestTeacherGradingGrader";
    }
    next({ name: defaultGradingTab, query: to.query });
    return;
  }

  next();
});

// 실시간 인증 체크를 위한 전역 navigation guard
router.beforeResolve((to, from, next) => {
  // 나의 검사 페이지에서 다른 나의 검사 페이지로 이동할 때도 체크
  if (to.path.startsWith("/my-test")) {
    const accessToken = getAccessToken();
    if (!accessToken) {
      console.log('Router beforeResolve: Token expired, redirecting to login');
      window.location.href = process.env.VUE_APP_API_LOGIN_URL;
      return;
    }
  }
  next();
});

export default router;
